import styled from 'styled-components'
import { Box, Text } from '@usap/uicomponents'

export const BoxContainer = styled(Box)`
  padding: 16px;
  width: 398px;
  min-height: 396px;
  &:nth-child(2) {
    margin-left: 10px; 
    margin-right: 10px; 
  }
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.12),
  0 1px 5px 0 rgba(0, 0, 0, 0.2),
  0 2px 2px 0 rgba(0, 0, 0, 0.14);
  border: 1px solid rgb(227, 227, 227);
  border-radius: 0;
  @media (max-width: 1024px) {
    width: 32.5%;
  }
  @media (max-width: 768px) {
    width: 47%;
    margin: 10px;
  }
  @media (max-width: 767px) {
    width: 100%;
    margin: 10px 0 0 0 !important;
  }
`

export const PartText = styled(Text)`
  width: 252px;
  color: rgb(46, 107, 158);
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0;
  line-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  @media (max-width: 1024px) {
    width: 170px;
  }

  @media (max-width: 320px) {
    width: 130px;
  }
`

export const PriceText = styled(Text)`
  width: 51px;
  color: rgb(51, 51, 51);
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 28px;
`

export const HeaderQandABox = styled(Box)`  
  display: flex;
  justify-content: space-between;
  height: 113px;
  flex-direction: row;
  @media (max-width: 767px) {
    justify-content: space-around;
  }
`

export const BlueBox = styled(Box)`
  width: 368px;
  min-height: 64px;
  padding: 12px;
  background: rgb(238, 244, 252);
  border-radius: 16px 16px 16px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  margin-top: 12px;
`

export const LabelText = styled(Text)`
  color: rgb(252, 126, 0);
  font-size: 32px;
  font-weight: bold;
  font-style: italic;
  letter-spacing: 0;
  width: 30px;
  line-height: 40px;
  margin-right: 8px;
`

export const AuthorText = styled(Text)`
  color: rgb(51, 51, 51);
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0;
  line-height: 20px;
  margin-top: 4px;
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  margin: 15.5px 0 15.5px 0;
  border-bottom: 1px solid rgb(227, 227, 227);
`

export const FooterQandAContainer = styled(Box)`
  flex-direction: row;
  justify-content: space-between;
`

export const AuthorBox = styled(Box)`
  height: 24px;
`

export const StatsText = styled(Text)`
  width: 164px;
  color: rgb(100, 100, 100);
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0;
  line-height: 20px;
`

export const ViewAllQandAText = styled(Text)`
  width: 87px;
  color: rgb(46, 107, 158);
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0;
  line-height: 20px;
`

export const linkHeaderStyle = { width: 100, alignSelf: 'center' }
export const headerImageLoader = {
  maxWidth: 'fit-content',
  maxHeight: 100,
}
export const authorBoxStyle = { textAlign: 'right' }
